import $ from 'jquery'

$(document).on('click', '[data-behaviour~="document-preview-link"]', (e) => {
  const url =
    Silverfin.Routes.document_path(
      Silverfin.currentFirmId,
      Silverfin.currentCompanyId,
      e.currentTarget.dataset.documentId
    ) + `?current_ledger_id=${Silverfin.currentLedgerId()}`

  window.open(url, '_blank')
  return false
})

$(document).on('click', '[data-behaviour~="document-download-link"]', (e) => {
  const url = Silverfin.Routes.file_document_path(
    Silverfin.currentFirmId,
    Silverfin.currentCompanyId,
    e.currentTarget.dataset.documentId
  )

  window.open(url)
  return false
})
